import { Component, OnInit } from "@angular/core";
import { environment } from "src/environments/environment";
import { SnackbarComponent } from "src/app/shared/components/snackbar/snackbar.component";
import { MatSnackBar } from "@angular/material/snack-bar";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NewslettersubcribeApiService } from "src/app/features/home/services/newslettersubcribe-api.service";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { AuthService } from "src/app/features/auth/services/auth.service";
import { Policy } from "../../models/policy.interface";
import { PolicyApiService } from "../../services/policy-api.service";
import { AuthDialogService } from "../../services/auth-dialog.service";
import { TranslateService } from "@ngx-translate/core";
import { TranslationService } from "src/app/core/services/translation.service";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrl: "./footer.component.scss",
  standalone: false,
})
export class FooterComponent implements OnInit {
  pageSize = 10;
  pageIndex = 0;
  policies: Policy[] = [];
  subscribeForm: FormGroup;
  isSubmitting = false;
  isShaking = false;
  currentUrl = "";
  isLoggedIn$!: Observable<boolean>;
  vendorBaseUrl: string = environment.vendorRegisterUrl;
  expandedSections = new Set<'customers' | 'about' | 'partners' | 'policies'>();

  toggleSection(section: 'customers' | 'about' | 'partners' | 'policies'): void {
    if (this.expandedSections.has(section)) {
      this.expandedSections.delete(section);
    } else {
      this.expandedSections.add(section);
    }
  }

  constructor(
    private __snackBar: MatSnackBar,
    private fb: FormBuilder,
    private newsletterService: NewslettersubcribeApiService,
    private router: Router,
    private authService: AuthService,
    private policyService: PolicyApiService,
    private translate: TranslateService,
    public translationService: TranslationService,
    private authDialogService: AuthDialogService
  ) {
    this.subscribeForm = this.fb.group({
      email: ["", [Validators.required, Validators.email]],
    });
    this.currentUrl = this.router.url;
  }

  openAuthModal(mode: 'login' | 'register' = 'login'): void {
    this.authDialogService.openAuthDialog(mode, undefined, 'header');
  }

  getPolicyTitle(policy: Policy): string {
    const normalized = `${policy.privacyKey} ${policy.title}`
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/đ/g, 'd')
      .toLowerCase();

    if (
      normalized.includes('tu khoa bi cam') ||
      normalized.includes('prohibited keyword') ||
      normalized.includes('banned keyword')
    ) {
      return this.translate.instant('FOOTER.PROHIBITED_KEYWORDS');
    }

    return policy.title;
  }

ngOnInit() {
  this.isLoggedIn$ = this.authService.isLoggedIn();

  this.policyService.getAllPolicies().subscribe(res => {
    if (res?.success) {
      const internalKeyPrefixes = ['POL-'];

      const hardcodedKeys = ['RegistrationPolicy', 'INFOPRIVACYPOLICY', 'DISPUTERESOLUTION'];

      this.policies = res.data.filter(policy =>
        policy.isActive &&
        !hardcodedKeys.includes(policy.privacyKey) &&
        !internalKeyPrefixes.some(prefix => policy.privacyKey.startsWith(prefix))
      );
    }
  });
}

  changeLang(lang: string) {
    this.translationService.setLanguage(lang);
  }

  submitSubscribe(): void {
    const emailControl = this.subscribeForm.get('email');
    if (this.subscribeForm.invalid || this.isSubmitting) {
      this.subscribeForm.markAllAsTouched();
      this.triggerShake();
      if (emailControl?.errors?.['required']) {
        this.showSnackBar(this.translate.instant('FOOTER.ERR_REQUIRED'), "error");
      } else if (emailControl?.errors?.['email']) {
        this.showSnackBar(this.translate.instant('FOOTER.ERR_FORMAT'), "error");
      }
      return;
    }
    this.isSubmitting = true;
    const email = this.subscribeForm.value.email;
    this.newsletterService.subscribeNewsletter(email).subscribe({
      next: (res) => {
        if (res?.success) {
          this.showSnackBar(this.translate.instant('FOOTER.SUCCESS_MSG'), "success");
          this.subscribeForm.reset();
        } else {
          this.showSnackBar(res?.message || this.translate.instant('FOOTER.ERROR_MSG'), "error");
        }
      },
      error: () => {
        this.showSnackBar(this.translate.instant('FOOTER.CONNECT_ERROR'), "error");
      },
      complete: () => {
        this.isSubmitting = false;
      },
    });
  }

  private triggerShake(): void {
    this.isShaking = true;
    setTimeout(() => {
      this.isShaking = false;
    }, 500);
  }

  private showSnackBar(message: string, type: 'success' | 'error') {
    this.__snackBar.openFromComponent(SnackbarComponent, {
      data: { message, type },
      duration: 6000,
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: ["custom-snackbar"],
    });
  }
}
